import React, { useState, useEffect } from 'react';
import './PayrollTable.css';

const API = '/api/payroll';

const ACTION_LABELS = {
  LOGIN:     { label: 'Вход',        color: '#2563eb', bg: '#dbeafe' },
  CREATE:    { label: 'Создание',    color: '#065f46', bg: '#d1fae5' },
  UPDATE:    { label: 'Изменение',   color: '#92400e', bg: '#fef3c7' },
  DELETE:    { label: 'Удаление',    color: '#991b1b', bg: '#fee2e2' },
  CALCULATE: { label: 'Расчёт',      color: '#6d28d9', bg: '#ede9fe' },
  APPROVE:   { label: 'Утверждение', color: '#065f46', bg: '#d1fae5' },
};

const ENTITY_LABELS = {
  employee:    '👤 Сотрудник',
  shift:       '📅 Смена',
  adjustment:  '⚡ Корректировка',
  payroll:     '💰 Ведомость',
  user:        '🔑 Пользователь',
  period:      '📆 Период',
};

export default function Logs() {
  const [logs, setLogs]         = useState([]);
  const [loading, setLoading]   = useState(false);
  const [filter, setFilter]     = useState({ entity: '', action: '' });

  useEffect(() => { loadLogs(); }, [filter]);

  async function loadLogs() {
    setLoading(true);
    let url = `${API}/logs?limit=200`;
    if (filter.entity) url += `&entity=${filter.entity}`;
    if (filter.action) url += `&action=${filter.action}`;
    const data = await fetch(url).then(r => r.json());
    setLogs(Array.isArray(data) ? data : []);
    setLoading(false);
  }

  function actionInfo(action) {
    return ACTION_LABELS[action] || { label: action, color: '#6b7280', bg: '#f3f4f6' };
  }

  function formatDate(dt) {
    if (!dt) return '—';
    const d = new Date(dt);
    return d.toLocaleString('ru', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit', second:'2-digit' });
  }

  return (
    <div className="pt-page">
      <div className="pt-header">
        <h2>Журнал действий</h2>
        <button className="btn-secondary" onClick={loadLogs} disabled={loading}>
          {loading ? 'Загрузка...' : '⟳ Обновить'}
        </button>
      </div>

      <div className="pt-filters">
        <select value={filter.action} onChange={e => setFilter(f => ({ ...f, action: e.target.value }))}>
          <option value="">Все действия</option>
          {Object.entries(ACTION_LABELS).map(([k, v]) => (
            <option key={k} value={k}>{v.label}</option>
          ))}
        </select>
        <select value={filter.entity} onChange={e => setFilter(f => ({ ...f, entity: e.target.value }))}>
          <option value="">Все объекты</option>
          {Object.entries(ENTITY_LABELS).map(([k, v]) => (
            <option key={k} value={k}>{v}</option>
          ))}
        </select>
        <span style={{ fontSize:13, color:'#9ca3af', alignSelf:'center' }}>
          Показано: {logs.length} записей
        </span>
      </div>

      <table className="pt-table">
        <thead>
          <tr>
            <th>Время</th>
            <th>Пользователь</th>
            <th>Действие</th>
            <th>Объект</th>
            <th>Описание</th>
          </tr>
        </thead>
        <tbody>
          {logs.length === 0 && (
            <tr>
              <td colSpan={5} style={{ textAlign:'center', color:'#9ca3af', padding:40 }}>
                {loading ? 'Загрузка...' : 'Действий пока нет'}
              </td>
            </tr>
          )}
          {logs.map(log => {
            const ai = actionInfo(log.action);
            return (
              <tr key={log.id}>
                <td style={{ fontSize:12, color:'#6b7280', whiteSpace:'nowrap' }}>
                  {formatDate(log.created_at)}
                </td>
                <td>
                  <div style={{ fontWeight:500, fontSize:13, color:'#111827' }}>{log.user_name || 'система'}</div>
                  <div style={{ fontSize:11, color:'#9ca3af' }}>{log.user_role || ''}</div>
                </td>
                <td>
                  <span className="badge" style={{ background: ai.bg, color: ai.color }}>
                    {ai.label}
                  </span>
                </td>
                <td style={{ fontSize:13, color:'#374151' }}>
                  {ENTITY_LABELS[log.entity] || log.entity}
                  {log.entity_id && <span style={{ color:'#9ca3af', fontSize:11 }}> #{log.entity_id}</span>}
                </td>
                <td style={{ fontSize:13, color:'#374151', maxWidth:400 }}>
                  {log.description || '—'}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
